import "./index.less";
import footlog1 from "@/images/footlog1.png";
import footlog2 from "@/images/footlog2.png";
import footlog3 from "@/images/footlog3.png";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="max-width">
        <div className="footer-content flex-b-c">
          <div className="footer-conten-item flex">
            <img src={footlog1} alt="" />
            <div>
              <div>品质保障</div>
              <div className="shop-pc">安全可靠的产品保障</div>
            </div>
          </div>
          <div className="footer-conten-item flex">
            <img src={footlog2} alt="" />
            <div>
              <div>暖心服务</div>
              <div className="shop-pc">“客户至上”的服务理念</div>
            </div>
          </div>
          <div className="footer-conten-item flex">
            <img src={footlog3} alt="" />
            <div>
              <div>高效配送</div>
              <div className="shop-pc">安全、准时、高效的配送服务</div>
            </div>
          </div>
        </div>
      </div>
      <footer className="flex-c-c">
        <div className="footer-info">
          <span>服务热线：400-921-1717</span>
          <span>总部地址：上海市浦东新区洲海路999号森兰国际A栋12-15楼</span>
        </div>
        <span>2023 版权所有 盈德气体 沪ICP备20000422号-1</span>
      </footer>
    </div>
  );
};

export default Footer;
